var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.way,_vm._g(_vm._b({tag:"component",attrs:{"loading":_vm.loading,"error":_vm.error,"response":_vm.response,"responses":_vm.responses,"comments":_vm.comments,"history":_vm.history,"voicebot":_vm.voicebot,"fetch":_vm.fetch,"set-stars":_vm.setStars}},'component',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }